
import { Component, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import { User } from "@/entities";
import { Getter } from "vuex-class";

@Component({
  name: "disclaimer-modal",
  components: {
    PModal,
  },
})
export default class DisclaimerModal extends Vue {
  @Getter("getDisclaimer") getDisclaimer!: string;
  @Getter("getLoggedUser") getLoggedUser!: User;
  public disclaimerAccepted = false;
  get showInactive(): boolean {
    return this.disclaimerAccepted || false;
  }

  set showInactive(value: boolean) {
    this.disclaimerAccepted = value;
    if (this.disclaimerAccepted) {
      this.$services.user.acceptDisclaimer();
    } else {
      this.$services.user.declineDisclaimer();
    }
  }

  async mounted(): Promise<void> {
    this.disclaimerAccepted = this.getLoggedUser.disclaimerAccepted || false;
    if (!this.disclaimerAccepted) {
      this.$bvModal.show("disclaimerModal");
    }
  }
}
